
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"670.85 682.79 259.77 295.07"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M920.18 714.09a243.606 243.606 0 00-238.9 0 20.549 20.549 0 00-10.434 17.645v83.797c0 70.809 49.191 135.54 122.44 161.07a22.749 22.749 0 0014.922.008h.012c73.21-25.527 122.4-90.254 122.4-161.06v-83.812a20.535 20.535 0 00-10.445-17.645zm-13.168 101.46c0 61.625-41.695 116.02-106.25 138.64-64.574-22.625-106.3-77.023-106.3-138.66v-81.77c32.535-17.98 69.102-27.414 106.27-27.414s73.738 9.434 106.27 27.414z"}})]),_c('path',{attrs:{"d":"M758.98 817.19c-4.695-4.527-12.168-4.394-16.699.3-4.527 4.692-4.39 12.169.3 16.696l39.485 38.094c4.574 4.414 11.82 4.414 16.395 0l74.055-71.422c4.695-4.528 4.832-12.004.304-16.7-4.527-4.695-12.008-4.831-16.703-.304l-65.855 63.508z"}})])
          )
        }
      }
    